/**
 * UserStatsRefreshReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserStatsRefreshReq
 */
export interface UserStatsRefreshReq {
  /** 用户ID列表（可选，为空时刷新所有用户） */
  user_ids?: string[]
  /** 每批处理数量，默认100，最大1000 */
  limit?: number
}

/**
 * UserStatsRefreshReq Schema
 */
export const UserStatsRefreshReqSchema: SchemaDefinition = {
  properties: {
    user_ids: {
      description: '用户ID列表（可选，为空时刷新所有用户）',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '用户ID列表',
    },
    limit: {
      description: '每批处理数量，默认100，最大1000',
      format: 'int',
      maximum: 1000,
      minimum: 0,
      type: 'integer',
      label: '每批处理数量',
    },
  },
  type: 'object',
}
